<script lang="ts">
      import { getScrollContext, ScrollTracker } from '$lib/ui/scroll/index.svelte'
      import { getPayloadContext } from '../context/ts/PayloadGlobals.svelte'
      import LexicalRender from '../lexical/LexicalRender.svelte'
      import Lexical from '../lexical/LexicalRender.svelte'
      import Globe from '../ui/Globe.svelte'

      $effect(() => {
            if (!payloadContext.footer) return
            if (!payloadContext.footer.length) return
            segments = [...payloadContext.footer]
      })

      const scroll: ScrollTracker = getScrollContext()

      const payloadContext = getPayloadContext()

      let segments: any[] = $state([])
</script>

{#key segments}
      <div class="spacer h-4"></div>
      <div class="h-auto mt-auto flex flex-col md:flex-row items-center w-full bg-black footer {scroll.scrollYPerc > 90 ? 'visible' : ''}">
            <div class="h-full text-white text-2xl md:text-4xl p-4 flex flex-col sm:flex-row justify-center w-full md:w-auto gap-6 overflow-hidden font-primary items-center">
                  <Globe class="h-auto" style="--rotation: calc(12000 * 6)"></Globe>
                  <div class="w-full flex gap-0 flex-col md:flex-row items-start">
                        {#each segments as segment, i (i)}
                              <div class="w-full footer-segment text-center md:text-left text-nowrap">
                                    <LexicalRender root={segment.lexical?.root ?? null}></LexicalRender>
                              </div>
                        {/each}
                  </div>
            </div>
            <div class="-order-1 md:order-2 md:ml-auto h-full flex items-center justify-center p-4 gap-2">
                  {#each payloadContext?.socials as net, i (i)}
                        {@render social(net)}
                  {/each}
            </div>
      </div>
{/key}

{#snippet social(item: any)}
      <a aria-label="link" href={item.link} target="_blank" class="aspect-square h-[3.2rem] rounded-full bg-[var(--df-slate)] shadow-md p-1/2 flex items-center justify-center social hover:bg-[var(--df-primary)]">
            <div
                  class="bg-black aspect-square"
                  style="width: {item.sizeOverride ? `${item.sizeOverride}%` : '100%'}; mask-image: url({item?.socialImage?.url
                        ? item.socialImage.url
                        : '/globe.svg'}); mask-size: contain; mask-position: center center; mask-repeat: no-repeat">
            </div>
      </a>
{/snippet}

<style>
      .footer {
            @apply opacity-0;
            transition: all 0.7s ease-in-out;
      }

      .footer:global(.visible) {
            @apply opacity-100;
      }

      .footer :global(.lexical-output) :global(p) {
            @apply text-center sm:text-left;
            color: white;
      }

      .footer-segment :global(p.lexical-paragraph) {
            line-height: 130%;
      }

      .social {
            transition: all 0.7s ease-in-out;
      }
</style>
